import { MediaManagerRenderedImageDto } from '../interfaces/supabase/media-manager/dto';
import { MediaManagerRenderedImage } from '../interfaces/supabase/media-manager/entity';

const mediaManagerRenderedImageDataMapper = (
  dto: MediaManagerRenderedImageDto,
): MediaManagerRenderedImage => {
  const {
    match_id,
    template_id,
    stage_id,
    championship_id,
    group_key,
    group_id,
    group_name,
    image_url,
    alias_match_template,
    created_at,
    updated_at,
    ...rest
  } = dto;

  return {
    ...rest,
    matchId: match_id,
    templateId: template_id,
    stageId: stage_id,
    championshipId: championship_id,
    groupKey: group_key,
    groupId: group_id,
    groupName: group_name,
    imageUrl: image_url,
    aliasMatchTemplate: alias_match_template,
    createdAt: created_at,
    updatedAt: updated_at,
  };
};

export default mediaManagerRenderedImageDataMapper;
